(() => {
  const getCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Unable to refresh cart.');
    }

    return response.json();
  };

  const updateCartEvent = (cart) => {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };

  const init = () => {
    const forms = Array.from(document.querySelectorAll('form')).filter((form) => {
      if (form.matches('[data-ps-add-form]')) {
        return false;
      }

      try {
        return new URL(form.action, window.location.href).pathname === '/cart/add';
      } catch (_error) {
        return false;
      }
    });

    forms.forEach((form) => {
      if (form.dataset.cartReady === 'true') {
        return;
      }

      form.dataset.cartReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        const originalLabel = submitButton?.value || submitButton?.textContent || 'Add to cart';
        form.setAttribute('aria-busy', 'true');

        if (submitButton) {
          submitButton.disabled = true;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: new URLSearchParams(new FormData(form)).toString(),
            credentials: 'same-origin',
          });

          if (!response.ok) {
            throw new Error('Unable to add item to cart.');
          }

          const addedItem = await response.json();
          const cart = await getCart();
          updateCartEvent(cart);

          if (submitButton) {
            if ('value' in submitButton) {
              submitButton.value = 'Added';
            } else {
              submitButton.textContent = 'Added';
            }
          }

          window.setTimeout(() => {
            if (!submitButton) {
              return;
            }
            if ('value' in submitButton) {
              submitButton.value = originalLabel;
            } else {
              submitButton.textContent = originalLabel;
            }
          }, 1800);

          if (addedItem?.title) {
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: addedItem } }));
          }
        } catch (_error) {
          if (submitButton) {
            if ('value' in submitButton) {
              submitButton.value = 'Try again';
            } else {
              submitButton.textContent = 'Try again';
            }
          }
        } finally {
          form.removeAttribute('aria-busy');
          if (submitButton) {
            submitButton.disabled = false;
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
